import {
    Grid,
    Box,
    Typography,
    TextField,
} from "@material-ui/core";
import useStyles from "../../assets/styles/styles";



const AnthropometryInput = ({ label, value, onChange, error, errorMessage, unit }) => {

    const classes = useStyles();

    return (
        <Grid style={{ marginLeft: "20px" }}  item xs={12} md={6}>
            <Box display="flex" flexDirection="column" gap={1}>
                <Typography className={classes.txtDescriptionAnthropometryForm}>{label}</Typography>
                <Box display="flex" alignItems="center" gap={2}>
                    <TextField
                        value={value}
                        onChange={onChange}
                        variant="outlined"
                        error={!!error}
                    />
                    <Typography className={classes.txtDescriptionAnthropometryForm}>{unit}</Typography>
                </Box>
                {error && (
                    <Typography variant="body2" color="error" className={classes.txtDescriptionAnthropometryError}>
                        {errorMessage}
                    </Typography>
                )}
            </Box>
        </Grid>
    );
};

export default AnthropometryInput;